import React from "react";
import "./corusle.css";

const Corusle = ({ videos, images, carouselId }) => {
    return (
        <section id="corusle">
            <div id={carouselId} className="carousel carousel-light slide">
                {/* Indicators */}
                {images && (
                    <>
                        <div className="carousel-indicators">
                            {images.map((_, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    data-bs-target={`#${carouselId}`} // Use unique ID here
                                    data-bs-slide-to={index}
                                    className={index === 0 ? "active" : ""}
                                    aria-current={index === 0 ? "true" : ""}
                                    aria-label={`Slide ${index + 1}`}
                                ></button>
                            ))}
                        </div>

                        {/* Images */}
                        <div className="carousel-inner">
                            {images.map((image, index) => (
                                <div
                                    key={index}
                                    className={`carousel-item ${
                                        index === 0 ? "active" : ""
                                    }`}
                                    data-bs-interval={1000 * (index + 1)}
                                >
                                    <div className="carousel-caption">
                                        <img src={image} alt="Work" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
                {videos && (
                    <>
                        <div className="carousel-indicators">
                            {videos.map((_, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    data-bs-target={`#${carouselId}`} // Use unique ID here
                                    data-bs-slide-to={index}
                                    className={index === 0 ? "active" : ""}
                                    aria-current={index === 0 ? "true" : ""}
                                    aria-label={`Slide ${index + 1}`}
                                ></button>
                            ))}
                        </div>

                        {/* videos */}
                        <div className="carousel-inner">
                            {videos.map((vid, index) => (
                                <div
                                    key={index}
                                    className={`carousel-item ${
                                        index === 0 ? "active" : ""
                                    }`}
                                    data-bs-interval={1000 * (index + 1)}
                                >
                                    <div className="carousel-caption">
                                        <video
                                            src={vid}
                                            controls
                                            preload="metadata"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {/* Navigation Buttons */}
                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target={`#${carouselId}`} // Use unique ID here
                    data-bs-slide="prev"
                >
                    <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target={`#${carouselId}`} // Use unique ID here
                    data-bs-slide="next"
                >
                    <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </section>
    );
};

export default Corusle;
